// Module 09 §8 — the dashboard `url` slug. Pure.
//
// Ports legacy `composables/format.js:768` `toSnakeCase`, applied at
// `views/App/CustomDashboard.vue:221,425,440` as `encodeURIComponent(toSnakeCase(name))`.
// The backend re-applies its own, narrower `to_snake_case` on save
// (`custom_dashboard_definition_main.py:181` — trim, whitespace → `_`, lowercase), so this
// must not disagree with it on the whitespace and case rules.

/** `Ad Spend-Report` → `ad_spend_report`; `adSpend` → `ad_spend`. */
export function toSnakeCase(value: unknown): string {
  return String(value)
    .replace(/([a-z0-9])([A-Z])/gu, '$1_$2')
    .replace(/[\s-]+/gu, '_')
    .toLowerCase()
}

/** The `url` field of an upsert body, exactly as the legacy save funnel builds it. */
export function dashboardUrlFromName(name: unknown): string {
  return encodeURIComponent(toSnakeCase(name))
}
